import { Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';

export const LANDING_ROUTES: Routes = [
    {
        path: 'landing',
        component: LandingComponent,
    },
];
